import { useEffect } from 'react';
import { Modal } from 'antd';

import { isMobile } from '../helpers/utils.helper';
import { useCapturePostHog } from './useCapturePostHog';

export const useCheckOrientation = () => {
  const { capturePostHogCustomEvent } = useCapturePostHog();

  useEffect(() => {
    const checkOrientation = () => {
      if (window.innerHeight > window.innerWidth && isMobile) {
        Modal.confirm({
          title: '',
          icon: '',
          centered: true,
          cancelButtonProps: { style: { display: 'none' } },
          content: `For the best experience,
        please rotate your phone sideways to Landscape mode`,
          onOk() {
            capturePostHogCustomEvent('CheckOrientation rotate phone');
          },
          onCancel() {
            capturePostHogCustomEvent('CheckOrientation close modal');
          },
        });
      }
    };
    checkOrientation();
  }, [capturePostHogCustomEvent]);
};
